import { useEffect } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

import {
  TUTORIAL_PROXY_ATTR,
  TUTORIAL_PROXY_SOURCE_ATTR,
  syncTutorialProxies,
} from "./tutorialTargets.js";

const PROXY_STYLE = { position: "fixed", pointerEvents: "none", display: "none" };

/**
 * Proxies fixed (ver tutorialTargets.js) para los pasos creados con withTutorialProxyTargets.
 * Mientras está activo los mantiene alineados con su target en cada frame; si se mueven,
 * emite un resize para que Joyride recoloque spotlight y tooltip.
 */
export function TutorialTargetProxies({ steps, active }) {
  useEffect(() => {
    if (!active) return undefined;
    let frame;
    const tick = () => {
      if (syncTutorialProxies()) window.dispatchEvent(new Event("resize"));
      frame = requestAnimationFrame(tick);
    };
    tick();
    return () => cancelAnimationFrame(frame);
  }, [active, steps]);

  if (!active || typeof document === "undefined") return null;

  return createPortal(
    steps
      .filter((step) => step.tutorialProxyKey)
      .map((step) => (
        <div
          key={step.tutorialProxyKey}
          aria-hidden="true"
          {...{
            [TUTORIAL_PROXY_ATTR]: step.tutorialProxyKey,
            [TUTORIAL_PROXY_SOURCE_ATTR]: step.tutorialSourceTarget,
          }}
          style={PROXY_STYLE}
        />
      )),
    document.body
  );
}

TutorialTargetProxies.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      tutorialProxyKey: PropTypes.string,
      tutorialSourceTarget: PropTypes.string,
    })
  ).isRequired,
  active: PropTypes.bool,
};
